import axios from "utils/axios"; 

/**
 * Отримуємо список всіх блоків
 * @param {int} userData.page
 * @param {string} userData.search
 * @returns 
 */
export const getUsers = async (userData) => {
    try {
        const response = await axios('/user', {params:userData});
        return response.data;
    } catch(error){
        console.log(error);
        return null;
    }
} 
 
/**
 * Отримуємо одного користувача
 * @param {int} userId 
 * @returns 
 */
export const getUser = async (userId) => {
    try {
        const response = await axios(`/user/${userId}`);
        return response.data;
    } catch(error){
        console.log(error);
        return null;
    }
}
 
/**
 * Зміна статусу користувача 
 * @param {int} userId 
 * @param {boolean} active 
 * @returns 
 */
export const setStatus = async (userId, active) =>{
    try {
        const response = await axios.post(`/user/status/${userId}`, {active});
        return response.data.stat;
    } catch(e) {
        console.error(e);
        return false;
    }
}


/**
 * Збереження користувача
 * @param {int} userId 
 * @param {Object} userData  = {
 *      access
 *      admin
 *      info
 *      user_email
 *      user_name
 *      user_picture
 *      user_status }
 */
export const saveUser = async(userId, userData) => {
    try {
        const response = await axios.post(`/user/${userId}`, userData);
        return response.data;
    } catch(e){
        console.error(e);
        return false;
    }
}  


/**
 * Видалення користувача
 * @param {int} userId 
 * @returns 
 */
export const deleteUser = async (userId) =>{
    try {
        const response = await axios.delete(`/user/${userId}`);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}